// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ve4C","textarea":"styles_textarea__95euf"};